export enum EFolderAssets {
  AVATAR = "avatar_url_user",
  BACKGROUND = "background_url_user",
  THUMBNAIL_CAMPAIGN = "thumbnail_campaign_user_id",
  THUMBNAIL_AFFILIATE = "thumbnail_affiliate_user_id",
  THUMBNAIL_AFFILIATE_CAMPAIGN = "thumbnail_aff_campaign_user_id",
  INSPIRATION_AFFILIATE_CAMPAIGN = "inspiration_aff_campaign_user_id",
  INSPIRATION_CAMPAIGN = "inspiration_campaign_user_id",
  POTENTIAL_DRAFT = "potential_draft_user_id",
  COMMENT = "comment_user_id",
  GALLERY_IMAGES = "galleries_url_user_id"
}

export enum EAffiliateOrderType {
  NORMAL = "NORMAL", // send order though Tiktok
  SEND_OUTSIDE = "SEND_OUTSIDE" // Send order outside Tiktok
}

export enum EntityInteractType {
  CAMPAIGN = "CAMPAIGN",
  CAMPAIGN_CPV = "CAMPAIGN_CPV",
  CHAT_MESSAGE = "CHAT_MESSAGE",
  COMMENT = "COMMENT",
  USER = "USER",
  BLOG = "BLOG"
}
export enum EContractStatus {
  INITIAL = "INITIAL",
  CUSTOMER_SIGNED = "CUSTOMER_SIGNED"
}

export enum ECommissionRate {
  BELOW_3 = "BELOW_3",
  B3_5 = "B3_5",
  B5_10 = "B5_10",
  B10_15 = "B10_15",
  OVER_15 = "OVER_15"
}

export enum EFilterAffiliate {
  HOT = "HOT",
  EASY_SELL = "EASY_SELL",
  SUITABLE = "SUITABLE"
}

export enum ESubmitStatus {
  APPLIED = "APPLIED",
  BRAND_APPROVED = "BRAND_APPROVED",
  WAITING = "WAITING",
  WORKING = "WORKING",
  FINISHED = "FINISHED",
  REJECTED = "REJECTED",
  NOT_ATTACH_LINK = "NOT_ATTACH_LINK",
  PREVIOUSLY_RECEIVED = "PREVIOUSLY_RECEIVED",
  NOT_AUTHORIZED_ORDER_SAMPLE = "NOT_AUTHORIZED_ORDER_SAMPLE",
  OVERDUE = "OVERDUE",
  PENDING_ACCEPTANCE = "PENDING_ACCEPTANCE",
  PAYMENT_COMPLETED = "PAYMENT_COMPLETED",
  REJECTED_ACCEPTANCE = "REJECTED_ACCEPTANCE",
  ACCEPTED_ACCEPTANCE = "ACCEPTED_ACCEPTANCE"
}
export enum EReasonDeliveryOrderSample {
  NOT_ATTACH_LINK = "NOT_ATTACH_LINK",
  PREVIOUSLY_RECEIVED = "PREVIOUSLY_RECEIVED",
  NOT_AUTHORIZED_ORDER_SAMPLE = "NOT_AUTHORIZED_ORDER_SAMPLE"
}
export enum ReasonEnum {
  PRODUCT_NOT_RECEIVED = "PRODUCT_NOT_RECEIVED",
  WRONG_PRODUCT_SENT = "WRONG_PRODUCT_SENT",
  INCOMPLETE_PREVIOUS_JOBS = "INCOMPLETE_PREVIOUS_JOBS",
  DEMO_NOT_APPROVED = "DEMO_NOT_APPROVED",
  OTHER = "OTHER"
}

export enum EAffiliateCampaignType {
  LIVE_STREAM = "LIVE_STREAM",
  VIDEO = "VIDEO"
}
export enum ETransactionType {
  DEPOSIT = "DEPOSIT", // Nạp tiền
  WITHDRAWAL = "WITHDRAWAL", // Rút tiền
  REFUND_WITHDRAWAL = "REFUND_WITHDRAWAL", // Hoàn tiền
  // BRAND_DEPOSIT_CAMPAIGN = 'BRAND_DEPOSIT_CAMPAIGN', // Cọc tiền cho chiến dịch
  PAY_CAMPAIGN = "PAY_CAMPAIGN" // Thanh toán cho KOL theo chiến dịch
}

export enum EAffiliateCampaignDeliveryType {
  NORMAL = "NORMAL",
  SEND_OUTSIDE = "SEND_OUTSIDE" // only for Brand send outside
}

export enum EFilterStatus {
  REMINDER = "REMINDER",
  WORKING = "WORKING",
  FINISHED = "FINISHED",
  OVERDUE = "OVERDUE",
  REJECTED = "REJECTED",
  NOT_ATTACH_LINK = "NOT_ATTACH_LINK", // Chưa gắn liên kết
  PREVIOUSLY_RECEIVED = "PREVIOUSLY_RECEIVED", // Nhãn hàng gửi trực tiếp
  NOT_AUTHORIZED_ORDER_SAMPLE = "NOT_AUTHORIZED_ORDER_SAMPLE", // Chưa ủy quyền đặt hàng mẫu
  INVITED_RECEIVE_SAMPLE = "INVITED_RECEIVE_SAMPLE" // Đợi phản hồi nhận mẫu
}

export enum ECheckKolSubmissionStatus {
  BRAND_APPROVED = "BRAND_APPROVED",
  ATTACHED_LINK = "ATTACHED_LINK",
  AUTHORIZED_ORDER_SAMPLE = "AUTHORIZED_ORDER_SAMPLE",
  WAITING_FOR_DELIVERY = "WAITING_FOR_DELIVERY",
  REJECTED = "REJECTED",
  OVERDUE = "OVERDUE",
  WORKING = "WORKING",
  PENDING_ACCEPTANCE = "PENDING_ACCEPTANCE",
  FINISHED = "FINISHED",
  PAYMENT_COMPLETED = "PAYMENT_COMPLETED",
  REJECTED_ACCEPTANCE = "REJECTED_ACCEPTANCE",
  ACCEPTED_ACCEPTANCE = "ACCEPTED_ACCEPTANCE",
  REQUESTED_RECEIVE_SAMPLE = "REQUESTED_RECEIVE_SAMPLE"
}

export enum ETypeNotification {
  CUSTOMIZE_NOTIFICATION_JOIN = "CUSTOMIZE_NOTIFICATION_JOIN",
  REMIND_ATTACH_LINK_AFFILIATE = "REMIND_ATTACH_LINK_AFFILIATE",
  REMIND_AUTHORIZED_SHOWCASE = "REMIND_AUTHORIZED_SHOWCASE",
  REVIEW_DRAFT = "REVIEW_DRAFT",
  FINALIZE_DRAFT = "FINALIZE_DRAFT",
  ACCEPT_SUBMISSION = "ACCEPT_SUBMISSION",
  REMIND_SUBMISSION = "REMIND_SUBMISSION",
  APPROVE_DRAFT = "APPROVE_DRAFT",
  REJECT_DRAFT = "REJECT_DRAFT",
  REJECT_SUBMISSION = "REJECT_SUBMISSION",
  REPLY_COMMENT = "REPLY_COMMENT",
  SEND_MESSAGE = "SEND_MESSAGE",
  COMMENT_DRAFT = "COMMENT_DRAFT",
  CREATE_CONTRACT = "CREATE_CONTRACT",
  NEW_CAMPAIGN = "NEW_CAMPAIGN",
  CUSTOMIZE_NOTIFICATION = "CUSTOMIZE_NOTIFICATION",
  DELIVERED = "DELIVERED",
  INVITE_JOIN_CAMPAIGN = "INVITE_JOIN_CAMPAIGN",
  REDIRECT_INTERNAL_APP = "REDIRECT_INTERNAL_APP",
  REDIRECT_OUTER_APP = "REDIRECT_OUTER_APP",
  UPDATE_SKU = "UPDATE_SKU",
  CAST_CAMP_PAYMENT = "CAST_CAMP_PAYMENT",
  REJECT_ACCEPTANCE = "REJECT_ACCEPTANCE",
  ACCEPT_ACCEPTANCE = "ACCEPT_ACCEPTANCE",
  INVITE_RECEIVE_SAMPLE = "INVITE_RECEIVE_SAMPLE"
}

export enum ERejectedReason {
  RESTRICTED_DUE_TO_OVERDUE_CAMPAIGNS = "RESTRICTED_DUE_TO_OVERDUE_CAMPAIGNS"
}

export enum Gender {
  MALE = "MALE",
  FEMALE = "FEMALE",
  NONE = "NONE"
}

export enum ECampaignType {
  COST_PER_VIEW = "COST_PER_VIEW",
  REVIEW_PRODUCT = "REVIEW_PRODUCT",
  AFFILIATE = "AFFILIATE"
}
export enum EFilterExplore {
  REGISTER = "REGISTER",
  REGISTERED = "REGISTERED",
  FINISHED = "FINISHED"
}
export enum EDraftStatus {
  WAITING = "WAITING",
  REVIEWED = "REVIEWED",
  FINALIZED = "FINALIZED",
  DRAFT = "DRAFT",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  REJECTED_ACCEPTANCE = "REJECTED_ACCEPTANCE",
  ACCEPTED_ACCEPTANCE = "ACCEPTED_ACCEPTANCE"
}
export enum CpvRejectReason {
  DOES_NOT_MATCH_THE_BRAND = "DOES_NOT_MATCH_THE_BRAND",
  CONTENT_QUALITY = "CONTENT_QUALITY",
  LOW_ENGAGEMENT = "LOW_ENGAGEMENT",
  FAKE_FOLLOWERS = "FAKE_FOLLOWERS",
  AUDIENCE_MISMATCH = "AUDIENCE_MISMATCH",
  LACK_OF_CREDIBILITY = "LACK_OF_CREDIBILITY"
}

export enum ECampaignStatus {
  DRAFT = "DRAFT",
  READY = "READY",
  PUBLISHED = "PUBLISHED",
  STARTED = "STARTED",
  PAUSED = "PAUSED",
  FINISHED = "FINISHED"
}

export enum CampaignStatus {
  DRAFT = "Draft",
  PUBLISH = "Publish",
  STARTED = "Started",
  COMPLETED = "Completed"
}

export enum ESocialType {
  TIKTOK = "TIKTOK",
  INSTAGRAM = "INSTAGRAM",
  FACEBOOK = "FACEBOOK",
  YOUTUBE = "YOUTUBE"
}

export enum EMediaType {
  IMAGE = "IMAGE",
  VIDEO = "VIDEO",
  LINK = "LINK"
}

export enum ESocialContent {
  POST = "POST",
  VIDEO = "VIDEO",
  IMAGE = "IMAGE",
  STORY = "STORY",
  REEL = "REEL",
  LIVESTREAM = "LIVESTREAM"
}

export enum ERejectSeason {
  BUSY_SCHEDULE = "BUSY_SCHEDULE",
  LACK_INTEREST = "LACK_INTEREST",
  HEALTH_REASONS = "HEALTH_REASONS",
  PERSONAL_COMMITMENTS = "PERSONAL_COMMITMENTS",
  OTHER = "OTHER"
}

export enum EDurationType {
  UNDER_60S = "UNDER_60S",
  FROM_1M_TO_3M = "FROM_1M_TO_3M",
  FROM_4M_TO_10M = "FROM_4M_TO_10M",
  FROM_11M_TO_15M = "FROM_11M_TO_15M",
  OTHER = "OTHER",
  TEMPLATE_1_IMAGE = "TEMPLATE_1_IMAGE",
  CAROUSEL_MAX_10_IMAGES = "CAROUSEL_MAX_10_IMAGES",
  CAROUSEL_11_TO_35_IMAGES = "CAROUSEL_11_TO_35_IMAGES",
  LENGTH_15S = "LENGTH_15S",
  WITH_IMAGE = "WITH_IMAGE",
  TEXT_ONLY_NO_IMAGE = "TEXT_ONLY_NO_IMAGE",
  FROM_3M_ONWARDS = "FROM_3M_ONWARDS",
  MAX_15S = "MAX_15S",
  MAX_60S = "MAX_60S",
  ONE_IMAGE = "ONE_IMAGE",
  MAX_10_IMAGES = "MAX_10_IMAGES",
  MAX_90S = "MAX_90S",
  FROM_1M_TO_10M = "FROM_1M_TO_10M",
  FROM_11M_TO_30M = "FROM_11M_TO_30M",
  FROM_30M_ONWARDS = "FROM_30M_ONWARDS"
}
export enum EReportReason {
  FORBIDDEN_ITEM = "FORBIDDEN_ITEM", // Hàng hóa cấm
  NON_COMPLIANT = "NON_COMPLIANT", // Không tuân thủ quy định
  SPAM = "SPAM", // Spam
  HARASSMENT = "HARASSMENT", // Quấy rối
  HATE_SPEECH = "HATE_SPEECH", // Phát ngôn thù hận
  OFFENSIVE = "OFFENSIVE", // Nội dung xúc phạm
  PORNOGRAPHIC = "PORNOGRAPHIC" // Khiêu dâm
}
export enum EValidateChannel {
  TIKTOK_EXISTED = "TIKTOK_EXISTED",
  FOLLOWER_COUNT_MUST_BE_MORE_THAN_1000 = "FOLLOWER_COUNT_MUST_BE_MORE_THAN_1000",
  KOC_MUST_HAVE_10_VIDEOS_WITHIN_THE_LAST_30_DAYS = "KOC_MUST_HAVE_10_VIDEOS_WITHIN_THE_LAST_30_DAYS"
}

export enum EUserListener {
  SHARE_GMV_UPDATED = "SHARE_GMV_UPDATED"
}

export enum EValidateUser {
  USERNAME_EXISTED = "USERNAME_EXISTED",
  SEND_OTP_ZALO_FAILED = "SEND_OTP_ZALO_FAILED",
  BANK_ACCOUNT_EXISTED = "BANK_ACCOUNT_EXISTED",
  USER_IS_BLOCKED = "USER_IS_BLOCKED",
  EMAIL_EXISTED = "EMAIL_EXISTED",
  USER_NOT_FOUND = "USER_NOT_FOUND",
  OTP_NOT_MATCHED = "OTP_NOT_MATCHED",
  PHONE_EXISTED = "PHONE_EXISTED",
  EMAIL_NOT_FOUND = "EMAIL_NOT_FOUND",
  YOU_CAN_ONLY_SEND_OTP_AFTER_60S = "YOU_CAN_ONLY_SEND_OTP_AFTER_60S",
  EMAIL_NOT_VERIFY = "EMAIL_NOT_VERIFY",
  EMAIL_NOT_MATCH = "EMAIL_NOT_MATCH",
  OTP_EXPIRED = "OTP_EXPIRED",
  PASSWORD_INVALID = "PASSWORD_INVALID",
  KOL_PRICING_EXISTED = "KOL_PRICING_EXISTED",
  OLD_PASSWORD_INVALID = "OLD_PASSWORD_INVALID",
  KOL_SUBMISSION_ALREADY_APPLIED = "KOL_SUBMISSION_ALREADY_APPLIED",
  PRE_DRAFT_IS_NOT_REVIEWED = "PRE_DRAFT_IS_NOT_REVIEWED",
  BALANCE_NOT_ENOUGH = "BALANCE_NOT_ENOUGH"
}

export enum EValidateDraft {
  VIDEO_IS_NOT_OWNED = "VIDEO_IS_NOT_OWNED",
  LACK_OF_PERMISSION = "LACK_OF_PERMISSION",
  INVALID_CODE_ADS = "INVALID_CODE_ADS",
  USER_NOT_LINKING_TIKTOK_YET = "USER_NOT_LINKING_TIKTOK_YET",
  VIDEO_SUBMIT_NOT_FOUND = "VIDEO_SUBMIT_NOT_FOUND",
  DEMO_LINK_ALREADY_EXISTED = "DEMO_LINK_ALREADY_EXISTED"
}

export enum EValidateGMV {
  NEED_MORE_PERMISSION = "NEED_MORE_PERMISSION",
  GMV_DATA_NOT_FOUND = "GMV_DATA_NOT_FOUND"
}

export enum EValidateReqProductSamples {
  REQUEST_PRODUCT_SAMPLE_EXISTED = "REQUEST_PRODUCT_SAMPLE_EXISTED",
  REQUEST_PRODUCT_SAMPLE_NOT_FOUND = "REQUEST_PRODUCT_SAMPLE_NOT_FOUND",
  FORBIDDEN = "FORBIDDEN"
}

export enum EStatusRequestProductSamples {
  PENDING = "PENDING",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED"
}

export enum EValidateCampaign {
  CAMPAIGN_NOT_FOUND = "CAMPAIGN_NOT_FOUND",
  CAMPAIGN_IS_NOT_STARTED = "CAMPAIGN_IS_NOT_STARTED",
  CAMPAIGN_IS_FULL_SLOT = "CAMPAIGN_IS_FULL_SLOT",
  CAMPAIGN_IS_NOT_PUBLISHED = "CAMPAIGN_IS_NOT_PUBLISHED",
  POTENTIAL_OF_CAMPAIGN_NOT_FOUND = "POTENTIAL_OF_CAMPAIGN_NOT_FOUND",
  CAMPAIGN_DOES_NOT_HAVE_DRAFT = "CAMPAIGN_DOES_NOT_HAVE_DRAFT",
  TITLE_IS_REQUIRED = "TITLE_IS_REQUIRED",
  DESCRIPTION_IS_REQUIRED = "DESCRIPTION_IS_REQUIRED",
  IS_PUBLIC_IS_REQUIRED = "IS_PUBLIC_IS_REQUIRED",
  LENGTH_DRAFT_DUE_DATE_FROM_1_TO_5 = "LENGTH_DRAFT_DUE_DATE_FROM_1_TO_5",
  GENDER_IS_REQUIRED = "GENDER_IS_REQUIRED",
  AGE_FROM_IS_REQUIRED = "AGE_FROM_IS_REQUIRED",
  AGE_TO_IS_REQUIRED = "AGE_TO_IS_REQUIRED",
  FOLLOWER_FROM_IS_REQUIRED = "FOLLOWER_FROM_IS_REQUIRED",
  FOLLOWER_TO_IS_REQUIRED = "FOLLOWER_TO_IS_REQUIRED",
  PRICE_PER_KOL_IS_REQUIRED = "PRICE_PER_KOL_IS_REQUIRED",
  DESCRIPTION_MUST_BE_GREATER_30 = "DESCRIPTION_MUST_BE_GREATER_30",
  PRICE_KOL_MUST_BE_GREATER_100K = "PRICE_KOL_MUST_BE_GREATER_100K",
  CREATE_CAMPAIGN_SUCCESSFULLY = "CREATE_CAMPAIGN_SUCCESSFULLY",
  UPDATE_CAMPAIGN_SUCCESSFULLY = "UPDATE_CAMPAIGN_SUCCESSFULLY",
  GET_CAMPAIGN_SUCCESSFULLY = "GET_CAMPAIGN_SUCCESSFULLY",
  DELETE_CAMPAIGN_SUCCESSFULLY = "DELETE_CAMPAIGN_SUCCESSFULLY"
}

export enum EValidateComment {
  COMMENT_NOT_FOUND = "COMMENT_NOT_FOUND",

  CREATE_COMMENT_SUCCESSFULLY = "CREATE_COMMENT_SUCCESSFULLY",
  UPDATE_COMMENT_SUCCESSFULLY = "UPDATE_COMMENT_SUCCESSFULLY",
  GET_COMMENT_SUCCESSFULLY = "GET_COMMENT_SUCCESSFULLY",
  DELETE_COMMENT_SUCCESSFULLY = "DELETE_COMMENT_SUCCESSFULLY"
}

export enum EValidateDraftSuccess {
  DRAFT_NOT_FOUND = "DRAFT_NOT_FOUND",
  DRAFT_IS_ALREADY_CREATED_IN_VERSION = "DRAFT_IS_ALREADY_CREATED_IN_VERSION",
  CREATE_DRAFT_SUCCESSFULLY = "CREATE_DRAFT_SUCCESSFULLY",
  UPDATE_DRAFT_SUCCESSFULLY = "UPDATE_DRAFT_SUCCESSFULLY",
  GET_DRAFT_SUCCESSFULLY = "GET_DRAFT_SUCCESSFULLY",
  GET_LINK_S3_DRAFT_SUCCESSFULLY = "GET_LINK_S3_DRAFT_SUCCESSFULLY",
  DELETE_DRAFT_SUCCESSFULLY = "DELETE_DRAFT_SUCCESSFULLY",
  DRAFT_IS_ALREADY_FINALIZED = "DRAFT_IS_ALREADY_FINALIZED"
}

export enum EValidateKolPricing {
  KOL_PRICING_NOT_FOUND = "KOL_PRICING_NOT_FOUND",
  KOL_PRICING_EXISTED = "KOL_PRICING_EXISTED",
  CREATE_KOL_PRICING_SUCCESSFULLY = "CREATE_KOL_PRICING_SUCCESSFULLY",
  UPDATE_KOL_PRICING_SUCCESSFULLY = "UPDATE_KOL_PRICING_SUCCESSFULLY",
  GET_KOL_PRICING_SUCCESSFULLY = "GET_KOL_PRICING_SUCCESSFULLY",
  DELETE_KOL_PRICING_SUCCESSFULLY = "DELETE_KOL_PRICING_SUCCESSFULLY"
}

export enum EKolSubmit {
  KOL_SUBMISSION_NOT_FOUND = "KOL_SUBMISSION_NOT_FOUND",
  CREATE_KOL_SUBMISSION_SUCCESSFULLY = "CREATE_KOL_SUBMISSION_SUCCESSFULLY",
  UPDATE_KOL_SUBMISSION_SUCCESSFULLY = "UPDATE_KOL_SUBMISSION_SUCCESSFULLY",
  GET_KOL_SUBMISSION_SUCCESSFULLY = "GET_KOL_SUBMISSION_SUCCESSFULLY",
  DELETE_KOL_SUBMISSION_SUCCESSFULLY = "DELETE_KOL_SUBMISSION_SUCCESSFULLY",
  KOL_SUBMISSION_ALREADY_APPLIED = "KOL_SUBMISSION_ALREADY_APPLIED",
  NOT_ALLOW_UPDATE_STATUS = "NOT_ALLOW_UPDATE_STATUS"
}

export enum EValidatePotential {
  POTENTIAL_NOT_FOUND = "POTENTIAL_NOT_FOUND",
  CREATE_POTENTIAL_SUCCESSFULLY = "CREATE_POTENTIAL_SUCCESSFULLY",
  UPDATE_POTENTIAL_SUCCESSFULLY = "UPDATE_POTENTIAL_SUCCESSFULLY",
  GET_POTENTIAL_SUCCESSFULLY = "GET_POTENTIAL_SUCCESSFULLY",
  DELETE_POTENTIAL_SUCCESSFULLY = "DELETE_POTENTIAL_SUCCESSFULLY"
}

export enum EStatusConversation {
  ACTIVE = "ACTIVE",
  BLOCK = "BLOCK"
}
export enum EKocCategory {
  UNBOXING = "UNBOXING",
  REVIEW = "REVIEW",
  GET_READY_WITH_ME = "GET_READY_WITH_ME",
  SHOW_FULL_BODY = "SHOW_FULL_BODY",
  DUPE_OR_BETTER = "DUPE_OR_BETTER",
  DAY_IN_THE_LIFE = "DAY_IN_THE_LIFE",
  TUTORIAL = "TUTORIAL"
}

export enum ACTION_NATIVE {
  OPEN_LINK = "OPEN_LINK",
  OPEN_NOTIFICATION = "OPEN_NOTIFICATION",
  NOTIFICATION_ACTION = "NOTIFICATION_ACTION",
  CONNECT_TIKTOK = "CONNECT_TIKTOK",
  CONNECT_TIKTOK_SUCCESS = "CONNECT_TIKTOK_SUCCESS",
  CONNECT_TIKTOK_EXISTED = "CONNECT_TIKTOK_EXISTED",
  CONNECT_TIKTOK_ERROR = "CONNECT_TIKTOK_ERROR",
  CONNECT_TIKTOK_FOLLOWER_COUNT_MUST_BE_MORE_THAN_1000 = "CONNECT_TIKTOK_FOLLOWER_COUNT_MUST_BE_MORE_THAN_1000",
  HAPTIC = "HAPTIC",
  BACK = "BACK",
  FORWARD = "FORWARD",
  LOGOUT = "LOGOUT",
  REFRESH = "REFRESH",
  FORCE_RELOAD = "FORCE_RELOAD",
  SEARCH = "SEARCH",
  SHARE = "SHARE",
  COPY = "COPY",
  NAVIGATE = "NAVIGATE",
  SYNC_TOKEN = "SYNC_TOKEN",
  PICK_FILES = "PICK_FILES",
  FILES_PICKED = "FILES_PICKED",
  ADD_BADGE_COUNT = "ADD_BADGE_COUNT",
  REQUEST_PERMISSION = "REQUEST_PERMISSION",
  CAMERA_IMAGE_CAPTURED = "CAMERA_IMAGE_CAPTURED",
  CAMERA_PERMISSION_DENIED = "CAMERA_PERMISSION_DENIED",
  STORE_REVIEW = "STORE_REVIEW",
  OPEN_SETTINGS = "OPEN_SETTINGS",
  SYNC_PERMISSION = "SYNC_PERMISSION",
  PING = "PING",
  UPDATE_TOKEN_FROM_WEB = "UPDATE_TOKEN_FROM_WEB",
  DEEP_LINK_CAMPAIGN = "DEEP_LINK_CAMPAIGN"
}

export enum PolicyStatus {
  PAYMENT = "PAYMENT",
  CONTRACT_CASTCAMPAIGN = "CONTRACT_CAMPAIGN"
}

export enum EReasonRejectAcceptance {
  VIDEO_IS_LATE = "VIDEO_IS_LATE",
  VIDEO_IS_WRONG_LINK = "VIDEO_IS_WRONG_LINK",
  VIDEO_IS_NOT_ATTACH_SHOP_CART = "VIDEO_IS_NOT_ATTACH_SHOP_CART",
  VIDEO_IS_ATTACH_WRONG_SHOP_CART = "VIDEO_IS_ATTACH_WRONG_SHOP_CART"
}
